import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin( ScrollTrigger )

let lenisInstance = null

export const getLenis = () => lenisInstance

/**
 * Reset window + Lenis scroll position (after AJAX page transitions).
 */
export const scrollToTop = () => {
	window.scrollTo(0, 0)
	document.documentElement.scrollTop = 0
	document.body.scrollTop = 0

	if (lenisInstance) {
		lenisInstance.scrollTo(0, { immediate: true, force: true })
	}
}

export const initSmoothScroll = () => {
	if ( lenisInstance ) {
		return lenisInstance
	}

	lenisInstance = new Lenis( {
		duration: 1.2,
		easing: (t) => Math.min( 1, 1.001 - Math.pow( 2, -10 * t ) ),
		smoothWheel: true,
	} )

	lenisInstance.on( 'scroll', ScrollTrigger.update )

	gsap.ticker.add( (time) => {
		lenisInstance.raf( time * 1000 )
	} )
	gsap.ticker.lagSmoothing( 0 )

	return lenisInstance
}
